<ul class="c-tabs-nav o-list-inline  o-list-bare">
  <li *ngFor="let tab of tabs" (click)="selectTab(tab)" 
      class="c-tabs-nav__item" [class.is-current]="tab.active">
    {{tab.tabTitle}}
  </li>
</ul>
<ng-content></ng-content>
